import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { applyContent } from "@/data/content";

const el = document.getElementById("root");
const app = (
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
const path = window.location.pathname.replace(/\/+$/, "") || "/";
const isPrivate = /^\/(admin|anteprima)(\/|$)/.test(path);

async function loadContent() {
  if (isPrivate) return null;
  try {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 3000);
    const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/public/content`, { signal: ctrl.signal });
    clearTimeout(t);
    const j = await r.json();
    applyContent(j.data || {});
    return j.updated_at || "";
  } catch {
    return null;
  }
}

loadContent().then((version) => {
  const prerendered = el.hasChildNodes() && window.__PRERENDERED__ === path;
  const sameContent = version === null || version === (window.__CONTENT_V__ || "");
  if (prerendered && sameContent) {
    hydrateRoot(el, app);
  } else {
    el.innerHTML = "";
    createRoot(el).render(app);
  }
});
